import { Reducer } from 'redux';
import {
  DetailsPanelActionTypes,
  DetailsPanelState,
  UploadingAttachment,
  DeleteAttachmentError,
  UploadAttachmentError
} from './types';

export const initialState: DetailsPanelState = {
  enquiryDetails: undefined,
  enquiryReferrals: [],
  isLoadingEnquiryDetails: false,
  combinedPDFDownloadURL: undefined,
  isDownloadingCombinedPDF: false,
  combinedZIPDownloadData: undefined,
  isDownloadingCombinedZIP: false,
  partialZipDownloadData: undefined,
  isDownloadingPartialZip: false,
  enquiryAutoRenewProperties: undefined,
  fetchingEnquiryAutoRenewProperties: false,
  enquiryAutoRenew: undefined,
  editingEnquiryAutoRenew: false,
  uploadingAttachments: [],
  deletingAttachments: [],
  uploadAttachmentErrors: [],
  deleteAttachmentErrors: [],
  moveEnquiryTeam: undefined,
  isMovingEnquiryTeam: false,
  updateAttachments: undefined,
  isUpdatingAttachments: false,
  enquiryAutoRenewSeries: [],
  isGettingEnquiryAutoRenewSeries: false,
  isArchivingEnquiry: false,
  archivedEnquiry: undefined,
  event: undefined,
  isAddingEvent: false,
  eventError: undefined
};

const reducer: Reducer<DetailsPanelState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_START: {
      return {
        ...state,
        isLoadingEnquiryDetails: true,
        enquiryDetails: undefined,
        enquiryReferrals: []
      };
    }
    case DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_SUCCESS: {
      return {
        ...state,
        isLoadingEnquiryDetails: false,
        enquiryDetails: action.payload
      };
    }
    case DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_FAILURE: {
      return {
        ...state,
        isLoadingEnquiryDetails: false,
        enquiryDetails: action.payload
      };
    }
    case DetailsPanelActionTypes.UPDATE_ENQUIRY_DETAILS_START: {
      return {
        ...state,
        updatingEnquiry: true,
        updateEnquiryError: undefined
      };
    }
    case DetailsPanelActionTypes.UPDATE_ENQUIRY_DETAILS_SUCCESS: {
      return {
        ...state,
        updatingEnquiry: false,
        enquiryDetails: action.payload
      };
    }
    case DetailsPanelActionTypes.UPDATE_ENQUIRY_DETAILS_FAILURE: {
      return {
        ...state,
        updatingEnquiry: false,
        updateEnquiryError: action.payload
      };
    }
    case DetailsPanelActionTypes.GET_REFERRAL_DETAILS_SUCCESS: {
      const { enquiryReferrals } = state;
      const newReferrals = enquiryReferrals.map((r) => {
        if (r.id === action.payload.id) {
          return {
            ...action.payload,
            isLoading: false
          };
        } else {
          return r;
        }
      });
      if (newReferrals.length === 0) {
        newReferrals.push({
          ...action.payload,
          isLoading: false
        });
      }
      return {
        ...state,
        enquiryReferrals: newReferrals
      };
    }
    case DetailsPanelActionTypes.GET_REFERRAL_DETAILS_FAILURE: {
      const { enquiryReferrals } = state;
      const newReferrals = enquiryReferrals.map((r) => {
        if (r.id === action.payload.id) {
          return {
            ...action.payload,
            isLoading: false
          };
        } else {
          return r;
        }
      });
      if (newReferrals.length === 0) {
        newReferrals.push({
          ...action.payload,
          isLoading: false
        });
      }
      return {
        ...state,
        enquiryReferrals: newReferrals
      };
    }
    case DetailsPanelActionTypes.SET_ENQUIRY_REFERRALS: {
      return {
        ...state,
        enquiryReferrals: action.payload
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_START: {
      return {
        ...state,
        isDownloadingCombinedPDF: true,
        combinedPDFDownloadURL: undefined
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_SUCCESS: {
      return {
        ...state,
        isDownloadingCombinedPDF: false,
        combinedPDFDownloadURL: action.payload
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_FAILURE: {
      return {
        ...state,
        isDownloadingCombinedPDF: false,
        combinedPDFDownloadURL: undefined
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_START: {
      return {
        ...state,
        isDownloadingCombinedZIP: true,
        combinedZIPDownloadData: undefined
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_SUCCESS: {
      const { combinedZIPDownloadData } = state;
      return {
        ...state,
        isDownloadingCombinedZIP: false,
        combinedZIPDownloadData: {
          ...combinedZIPDownloadData,
          blobData: action.payload.blobData,
          fileName: action.payload.fileName
        }
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_FAILURE: {
      return {
        ...state,
        isDownloadingCombinedZIP: false,
        combinedZIPDownloadData: undefined
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_PARTIAL_ZIP_START: {
      const { partialZipDownloadData } = state;
      return {
        ...state,
        isDownloadingPartialZip: true,
        partialZipDownloadData: {
          ...partialZipDownloadData,
          jobId: action.payload.jobId,
          seqNo: action.payload.seqNo,
          aoName: action.payload.aoName
        }
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_PARTIAL_ZIP_SUCCESS: {
      const { partialZipDownloadData } = state;
      return {
        ...state,
        isDownloadingPartialZip: false,
        partialZipDownloadData: {
          ...partialZipDownloadData,
          blobData: action.payload.blobData,
          fileName: action.payload.fileName
        }
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_PARTIAL_ZIP_FAILURE: {
      return {
        ...state,
        isDownloadingPartialZip: false,
        partialZipDownloadData: undefined
      };
    }
    case DetailsPanelActionTypes.VIEW_ATTACHMENT_START: {
      return {
        ...state,
        fetchingAttachment: true,
        currentAttachment: undefined
      };
    }
    case DetailsPanelActionTypes.VIEW_ATTACHMENT_SUCCESS: {
      return {
        ...state,
        fetchingAttachment: false,
        currentAttachment: action.payload
      };
    }
    case DetailsPanelActionTypes.VIEW_ATTACHMENT_FAILURE: {
      return {
        ...state,
        fetchingAttachment: false,
        currentAttachment: undefined
      };
    }
    case DetailsPanelActionTypes.SET_PREVIEW_CONTENT: {
      return {
        ...state,
        previewContent: action.payload
      };
    }
    case DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_PROPERTIES_START: {
      return {
        ...state,
        fetchingEnquiryAutoRenewProperties: true,
        enquiryAutoRenewProperties: undefined
      };
    }
    case DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_PROPERTIES_SUCCESS: {
      return {
        ...state,
        fetchingEnquiryAutoRenewProperties: false,
        enquiryAutoRenewProperties: action.payload
      };
    }
    case DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_PROPERTIES_FAILURE: {
      return {
        ...state,
        fetchingEnquiryAutoRenewProperties: false,
        enquiryAutoRenewProperties: undefined
      };
    }
    case DetailsPanelActionTypes.EDIT_ENQUIRY_AUTO_RENEW_START: {
      return {
        ...state,
        editingEnquiryAutoRenew: true,
        enquiryAutoRenew: undefined
      };
    }
    case DetailsPanelActionTypes.EDIT_ENQUIRY_AUTO_RENEW_SUCCESS: {
      return {
        ...state,
        editingEnquiryAutoRenew: false,
        enquiryAutoRenew: action.payload
      };
    }
    case DetailsPanelActionTypes.EDIT_ENQUIRY_AUTO_RENEW_FAILURE: {
      return {
        ...state,
        editingEnquiryAutoRenew: false,
        enquiryAutoRenew: undefined
      };
    }
    case DetailsPanelActionTypes.EDIT_ENQUIRY_AUTO_RENEW_RESET: {
      return {
        ...state,
        editingEnquiryAutoRenew: false,
        enquiryAutoRenew: undefined
      };
    }
    case DetailsPanelActionTypes.ARCHIVE_ENQUIRY_START: {
      return {
        ...state,
        isArchivingEnquiry: true
      };
    }
    case DetailsPanelActionTypes.ARCHIVE_ENQUIRY_SUCCESS: {
      return {
        ...state,
        isArchivingEnquiry: false,
        enquiryDetails: action.payload,
        archivedEnquiry: action.payload
      };
    }
    case DetailsPanelActionTypes.ARCHIVE_ENQUIRY_FAILURE: {
      return {
        ...state,
        isArchivingEnquiry: false
      };
    }
    case DetailsPanelActionTypes.UPLOAD_ATTACHMENT_START: {
      const uploadingAttachment: UploadingAttachment = {
        enquiryId: action.payload.enquiryId,
        assetOwnerId: action.payload.assetOwnerId,
        uuid: action.payload.uuid
      };
      return {
        ...state,
        uploadingAttachments: [
          ...state.uploadingAttachments,
          uploadingAttachment
        ]
      };
    }
    case DetailsPanelActionTypes.UPLOAD_ATTACHMENT_SUCCESS: {
      const uploadingAttachments = state.uploadingAttachments.filter(
        (a: UploadingAttachment) => {
          return a.uuid !== action.payload.uuid;
        }
      );
      return {
        ...state,
        uploadingAttachments
      };
    }
    case DetailsPanelActionTypes.UPLOAD_ATTACHMENT_FAILURE: {
      const uploadingAttachments = state.uploadingAttachments.filter(
        (a: UploadingAttachment) => {
          return a.uuid !== action.payload.uuid;
        }
      );
      return {
        ...state,
        uploadingAttachments,
        uploadAttachmentErrors: [
          ...state.uploadAttachmentErrors,
          action.payload
        ]
      };
    }
    case DetailsPanelActionTypes.CLEAR_UPLOAD_ATTACHMENT_ERROR: {
      const uploadAttachmentErrors = state.uploadAttachmentErrors.filter(
        (e: UploadAttachmentError) => {
          return e.uuid !== action.payload.uuid;
        }
      );
      return {
        ...state,
        uploadAttachmentErrors
      };
    }
    case DetailsPanelActionTypes.DELETE_ATTACHMENT_START: {
      return {
        ...state,
        deletingAttachments: [...state.deletingAttachments, action.payload.id]
      };
    }
    case DetailsPanelActionTypes.DELETE_ATTACHMENT_SUCCESS: {
      const deletingAttachments = state.deletingAttachments.filter(
        (a: number) => {
          return a !== action.payload;
        }
      );
      return {
        ...state,
        deletingAttachments
      };
    }
    case DetailsPanelActionTypes.DELETE_ATTACHMENT_FAILURE: {
      const deletingAttachments = state.deletingAttachments.filter(
        (a: number) => {
          return a !== action.payload.id;
        }
      );
      return {
        ...state,
        deletingAttachments,
        deleteAttachmentErrors: [
          ...state.deleteAttachmentErrors,
          action.payload
        ]
      };
    }
    case DetailsPanelActionTypes.CLEAR_DELETE_ATTACHMENT_ERROR: {
      const deleteAttachmentErrors = state.deleteAttachmentErrors.filter(
        (e: DeleteAttachmentError) => {
          return e.id !== action.payload.id;
        }
      );
      return {
        ...state,
        deleteAttachmentErrors
      };
    }
    case DetailsPanelActionTypes.MOVE_ENQUIRY_TEAM_START: {
      return {
        ...state,
        moveEnquiryTeam: undefined,
        isMovingEnquiryTeam: true
      };
    }
    case DetailsPanelActionTypes.MOVE_ENQUIRY_TEAM_SUCCESS: {
      const enquiryDetails = state.enquiryDetails;
      const updatedEnqDetails = {
        ...enquiryDetails,
        project_id: action.payload.data.project_id
      };
      return {
        ...state,
        moveEnquiryTeam: action.payload,
        enquiryDetails: updatedEnqDetails,
        isMovingEnquiryTeam: false
      };
    }
    case DetailsPanelActionTypes.MOVE_ENQUIRY_TEAM_FAILURE: {
      return {
        ...state,
        moveEnquiryTeam: undefined,
        isMovingEnquiryTeam: false
      };
    }
    case DetailsPanelActionTypes.UPDATE_ATTACHMENT_START: {
      return {
        ...state,
        isUpdatingAttachments: true,
        updateAttachments: undefined
      };
    }
    case DetailsPanelActionTypes.UPDATE_ATTACHMENT_SUCCESS: {
      return {
        ...state,
        isUpdatingAttachments: false,
        updateAttachments: action.payload
      };
    }
    case DetailsPanelActionTypes.UPDATE_ATTACHMENT_FAILURE: {
      return {
        ...state,
        isUpdatingAttachments: false,
        updateAttachments: undefined
      };
    }
    case DetailsPanelActionTypes.UPDATE_ATTACHMENT_CLEAR: {
      return {
        ...state,
        isUpdatingAttachments: false,
        updateAttachments: undefined
      };
    }
    case DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_SERIES_START: {
      return {
        ...state,
        enquiryAutoRenewSeries: [],
        isGettingEnquiryAutoRenewSeries: true
      };
    }
    case DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_SERIES_SUCCESS: {
      return {
        ...state,
        enquiryAutoRenewSeries: action.payload.series,
        isGettingEnquiryAutoRenewSeries: false
      };
    }
    case DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_SERIES_FAILURE: {
      return {
        ...state,
        enquiryAutoRenewSeries: [],
        isGettingEnquiryAutoRenewSeries: false
      };
    }
    case DetailsPanelActionTypes.ADD_EVENT_START: {
      return {
        ...state,
        isAddingEvent: true,
        event: undefined,
        eventError: undefined
      };
    }
    case DetailsPanelActionTypes.ADD_EVENT_SUCCESS: {
      return {
        ...state,
        isAddingEvent: false,
        event: action.payload,
        eventError: undefined
      };
    }
    case DetailsPanelActionTypes.ADD_EVENT_FAILURE: {
      return {
        ...state,
        isAddingEvent: false,
        event: undefined,
        eventError: action.payload
      };
    }
    default:
      return state;
  }
};

export default reducer;
